import React from 'react'

export const ConnectLine01 = () => (
  <svg
    className='absolute'
    xmlns='http://www.w3.org/2000/svg'
    width='213'
    height='366'
    viewBox='0 0 213 366'
    fill='none'
  >
    <path
      d='M0 2H181C197.569 2 211 15.4315 211 32V366'
      stroke='url(#paint0_linear_15413_48036)'
      stroke-width='3'
      stroke-dasharray='6 6'
    />
    <defs>
      <linearGradient
        id='paint0_linear_15413_48036'
        x1='105.5'
        y1='2'
        x2='105.5'
        y2='366'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#6596D7' />
        <stop offset='1' stop-color='#58C1B3' />
      </linearGradient>
    </defs>
  </svg>
)

export const ConnectLine01Mobile = () => (
  <svg
    width='76'
    height='152'
    viewBox='0 0 76 152'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 0V52.0811C1 56.4994 4.58172 60.0811 9 60.0811H67C71.4183 60.0811 75 63.6628 75 68.0811V152'
      stroke='url(#paint0_linear_18138_249273)'
      stroke-dasharray='6 6'
    />
    <defs>
      <linearGradient
        id='paint0_linear_18138_249273'
        x1='38'
        y1='0'
        x2='38'
        y2='152'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#6596D7' />
        <stop offset='1' stop-color='#58C1B3' />
      </linearGradient>
    </defs>
  </svg>
)

export const ConnectLine02 = () => (
  <svg
    className='absolute left-[-400px] top-[250px]'
    xmlns='http://www.w3.org/2000/svg'
    width='394'
    height='359'
    viewBox='0 0 394 359'
    fill='none'
  >
    <path
      d='M393.5 1.5H31.5C14.9315 1.5 1.5 14.9315 1.5 31.5V359'
      stroke='url(#paint0_linear_15413_48037)'
      stroke-width='3'
      stroke-dasharray='6 6'
    />
    <defs>
      <linearGradient
        id='paint0_linear_15413_48037'
        x1='197.5'
        y1='1.5'
        x2='197.5'
        y2='359'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#58C1B3' />
        <stop offset='1' stop-color='#8484F6' />
      </linearGradient>
    </defs>
  </svg>
)

export const ConnectLine02Mobile = () => (
  <svg
    width='174'
    height='111'
    viewBox='0 0 174 111'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M173 0V35.875C173 40.2933 169.418 43.875 165 43.875H9C4.58172 43.875 0.999997 47.4567 0.999997 51.875V111'
      stroke='url(#paint0_linear_18138_249274)'
      stroke-dasharray='6 6'
    />
    <defs>
      <linearGradient
        id='paint0_linear_18138_249274'
        x1='87'
        y1='0'
        x2='87'
        y2='111'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#58C1B3' />
        <stop offset='1' stop-color='#8484F6' />
      </linearGradient>
    </defs>
  </svg>
)

export const ConnectLine03 = () => (
  <svg
    className='absolute mt-[200px]'
    xmlns='http://www.w3.org/2000/svg'
    width='293'
    height='339'
    viewBox='0 0 293 339'
    fill='none'
  >
    <path
      d='M0.5 2H261.5C278.069 2 291.5 15.4315 291.5 32V339'
      stroke='url(#paint0_linear_15413_48038)'
      stroke-width='3'
      stroke-dasharray='6 6'
    />
    <defs>
      <linearGradient
        id='paint0_linear_15413_48038'
        x1='146'
        y1='2'
        x2='146'
        y2='339'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#8484F6' />
        <stop offset='1' stop-color='#65C2D7' />
      </linearGradient>
    </defs>
  </svg>
)

export const ConnectLine03Mobile = () => (
  <svg
    width='64'
    height='204'
    viewBox='0 0 64 204'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 0V72.6351C1 77.0534 4.58172 80.6351 9 80.6351H55C59.4183 80.6351 63 84.2169 63 88.6351V204'
      stroke='url(#paint0_linear_18138_249278)'
      stroke-dasharray='6 6'
    />
    <defs>
      <linearGradient
        id='paint0_linear_18138_249278'
        x1='32'
        y1='0'
        x2='32'
        y2='204'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#6596D7' />
        <stop offset='1' stop-color='#58C1B3' />
      </linearGradient>
    </defs>
  </svg>
)

export const Background01Desktop = () => (
  <svg
    width='516'
    height='748'
    viewBox='0 0 516 748'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <ellipse
      cx='240.457'
      cy='614.311'
      rx='35.3455'
      ry='35.3348'
      transform='rotate(38.8965 240.457 614.311)'
      fill='url(#paint0_linear_15413_48045)'
    />
    <foreignObject x='-134.031' y='97.9741' width='551.703' height='551.668'>
      <div className='backdrop-filter:blur(5px);clip-path:url(#bgblur_0_15413_48045_clip_path);height:100%;width:100%'></div>
    </foreignObject>
    <path
      data-figma-bg-blur-radius='10'
      d='M317.614 515.638C239.318 612.683 97.138 627.877 0.0411581 549.539C-97.0556 471.202 -112.268 329.023 -33.9728 231.979C44.3227 134.934 186.503 119.74 283.6 198.078C380.697 276.415 395.909 418.594 317.614 515.638Z'
      stroke='url(#paint1_radial_15413_48045)'
      stroke-width='80'
    />
    <foreignObject x='-82.7681' y='147.721' width='450.528' height='450.5'>
      <div className='backdrop-filter:blur(5px);height:100%;width:100%'></div>
    </foreignObject>
    <path
      data-figma-bg-blur-radius='10'
      d='M286.698 489.313C222.472 568.919 105.842 581.381 26.1953 517.122C-53.4518 452.863 -65.9315 336.235 -1.70556 256.629C62.5203 177.023 179.15 164.561 258.797 228.82C338.444 293.079 350.924 409.707 286.698 489.313Z'
      stroke='url(#paint2_radial_15413_48045)'
      stroke-opacity='0.49'
      stroke-width='60'
    />
    <path
      d='M245.406 455.997C199.576 512.801 116.347 521.7 59.5027 475.839C2.65877 429.977 -6.24138 346.747 39.5879 289.943C85.4171 233.14 168.647 224.24 225.491 270.102C282.335 315.963 291.235 399.193 245.406 455.997Z'
      stroke='url(#paint3_radial_15413_48045)'
      stroke-width='80'
    />
    <ellipse
      cx='392.768'
      cy='289.491'
      rx='12.7636'
      ry='12.7598'
      transform='rotate(38.8965 392.768 289.491)'
      fill='#8DE0D5'
    />
    <defs>
      <clipPath id='bgblur_0_15413_48045_clip_path'>
        <path
          transform='translate(134.031 -97.9741)'
          d='M317.614 515.638C239.318 612.683 97.138 627.877 0.0411581 549.539C-97.0556 471.202 -112.268 329.023 -33.9728 231.979C44.3227 134.934 186.503 119.74 283.6 198.078C380.697 276.415 395.909 418.594 317.614 515.638Z'
        />
      </clipPath>
      <linearGradient
        id='paint0_linear_15413_48045'
        x1='275.802'
        y1='649.645'
        x2='205.133'
        y2='578.954'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#007583' />
        <stop offset='0.750282' stop-color='#9FCDD7' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_15413_48045'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(128.699 378.163) rotate(127.686) scale(353.917 354.023)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint2_radial_15413_48045'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(131.872 376.497) rotate(127.686) scale(286.572 286.659)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint3_radial_15413_48045'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(133.997 375.791) rotate(127.686) scale(229.258 229.327)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
    </defs>
  </svg>
)

export const Background02Desktop = () => (
  <svg
    width='518'
    height='532'
    viewBox='0 0 518 532'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <ellipse
      cx='493.656'
      cy='391.036'
      rx='35.3455'
      ry='35.3348'
      fill='url(#paint0_linear_15413_48073)'
    />
    <foreignObject x='-10' y='-10' width='551.748' height='551.587'>
      <div className='backdrop-filter:blur(5px);clip-path:url(#bgblur_0_15413_48073_clip_path);height:100%;width:100%'></div>
    </foreignObject>
    <path
      data-figma-bg-blur-radius='10'
      d='M491.747 265.793C491.747 390.484 390.632 491.587 265.874 491.587C141.116 491.587 40 390.484 40 265.793C40 141.103 141.116 40 265.874 40C390.632 40 491.747 141.103 491.747 265.793Z'
      stroke='url(#paint1_radial_15413_48073)'
      stroke-width='80'
    />
    <ellipse
      cx='86.6922'
      cy='197.186'
      rx='49.5818'
      ry='49.5668'
      fill='#405985'
    />
    <foreignObject x='40.5913' y='39.5' width='450.565' height='450.435'>
      <div className='backdrop-filter:blur(5px);height:100%;width:100%'></div>
    </foreignObject>
    <path
      data-figma-bg-blur-radius='10'
      d='M451.156 264.717C451.156 367.002 368.211 449.935 265.874 449.935C163.537 449.935 80.5913 367.002 80.5913 264.717C80.5913 162.433 163.537 79.5 265.874 79.5C368.211 79.5 451.156 162.433 451.156 264.717Z'
      stroke='url(#paint2_radial_15413_48073)'
      stroke-opacity='0.49'
      stroke-width='60'
    />
    <path
      d='M398.1 264.716C398.1 337.703 338.912 396.89 265.874 396.89C192.836 396.89 133.648 337.703 133.648 264.716C133.648 191.73 192.836 132.542 265.874 132.542C338.912 132.542 398.1 191.73 398.1 264.716Z'
      stroke='url(#paint3_radial_15413_48073)'
      stroke-width='80'
    />
    <ellipse
      cx='408.238'
      cy='42.5962'
      rx='12.7636'
      ry='12.7598'
      fill='#4DB8BA'
    />
    <defs>
      <clipPath id='bgblur_0_15413_48073_clip_path'>
        <path
          transform='translate(10 10)'
          d='M491.747 265.793C491.747 390.484 390.632 491.587 265.874 491.587C141.116 491.587 40 390.484 40 265.793C40 141.103 141.116 40 265.874 40C390.632 40 491.747 141.103 491.747 265.793Z'
        />
      </clipPath>
      <linearGradient
        id='paint0_linear_15413_48073'
        x1='529.001'
        y1='426.371'
        x2='458.331'
        y2='355.68'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#42A7C3' />
        <stop offset='0.750282' stop-color='#8ADBF0' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_15413_48073'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(258.396 277.422) rotate(88.7893) scale(353.917 354.023)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint2_radial_15413_48073'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(259.819 274.133) rotate(88.7893) scale(286.572 286.659)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint3_radial_15413_48073'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(261.03 272.249) rotate(88.7893) scale(229.258 229.327)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
    </defs>
  </svg>
)

export const Background03Desktop = () => (
  <svg
    width='715'
    height='715'
    viewBox='0 0 715 715'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <ellipse
      cx='477.806'
      cy='264.315'
      rx='35.3455'
      ry='35.3348'
      transform='rotate(-26.9569 477.806 264.315)'
      fill='url(#paint0_linear_15413_48322)'
    />
    <foreignObject x='81.5615' y='81.5737' width='551.828' height='551.733'>
      <div className='backdrop-filter:blur(5px);clip-path:url(#bgblur_0_15413_48322_clip_path);height:100%;width:100%'></div>
    </foreignObject>
    <path
      data-figma-bg-blur-radius='10'
      d='M558.808 255.047C615.333 366.19 571.035 502.145 459.833 558.701C348.63 615.256 212.669 570.977 156.144 459.834C99.6186 348.691 143.916 212.735 255.119 156.18C366.321 99.6246 502.283 143.904 558.808 255.047Z'
      stroke='url(#paint1_radial_15413_48322)'
      stroke-width='80'
    />
    <ellipse
      cx='217.44'
      cy='206.27'
      rx='49.5818'
      ry='49.5668'
      transform='rotate(-26.9569 217.44 206.27)'
      fill='#5858DF'
    />
    <foreignObject x='131.672' y='131.205' width='450.63' height='450.553'>
      <div className='backdrop-filter:blur(5px);height:100%;width:100%'></div>
    </foreignObject>
    <path
      data-figma-bg-blur-radius='10'
      d='M522.139 272.489C568.506 363.66 532.169 475.183 440.951 521.574C349.733 567.966 238.204 531.644 191.837 440.474C145.469 349.303 181.807 237.78 273.025 191.388C364.243 144.997 475.771 181.318 522.139 272.489Z'
      stroke='url(#paint2_radial_15413_48322)'
      stroke-opacity='0.49'
      stroke-width='60'
    />
    <path
      d='M474.847 296.54C507.933 361.596 482.007 441.184 416.905 474.293C351.803 507.403 272.214 481.477 239.128 416.421C206.042 351.365 231.968 271.777 297.07 238.667C362.172 205.558 441.76 231.483 474.847 296.54Z'
      stroke='url(#paint3_radial_15413_48322)'
      stroke-width='80'
    />
    <ellipse
      cx='514.682'
      cy='146.189'
      rx='12.7636'
      ry='12.7598'
      transform='rotate(-26.9569 514.682 146.189)'
      fill='#4DB8BA'
    />
    <defs>
      <clipPath id='bgblur_0_15413_48322_clip_path'>
        <path
          transform='translate(-81.5615 -81.5737)'
          d='M558.808 255.047C615.333 366.19 571.035 502.145 459.833 558.701C348.63 615.256 212.669 570.977 156.144 459.834C99.6186 348.691 143.916 212.735 255.119 156.18C366.321 99.6246 502.283 143.904 558.808 255.047Z'
        />
      </clipPath>
      <linearGradient
        id='paint0_linear_15413_48322'
        x1='513.151'
        y1='299.65'
        x2='442.482'
        y2='228.959'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#42A7C3' />
        <stop offset='0.750282' stop-color='#8ADBF0' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_15413_48322'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(356.082 371.195) rotate(61.8324) scale(353.917 354.023)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint2_radial_15413_48322'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(355.859 367.619) rotate(61.8324) scale(286.572 286.659)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint3_radial_15413_48322'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(356.085 365.39) rotate(61.8324) scale(229.258 229.327)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
    </defs>
  </svg>
)

export const Background01Mobile = () => (
  <svg
    width='187'
    height='187'
    viewBox='0 0 187 187'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <ellipse
      cx='117.907'
      cy='153.307'
      rx='8.82082'
      ry='8.81815'
      transform='rotate(38.8965 117.907 153.307)'
      fill='url(#paint0_linear_18131_197723)'
    />
    <foreignObject x='16.9448' y='16.9463' width='152.692' height='152.683'>
      <div className='backdrop-filter:blur(5px);clip-path:url(#bgblur_0_18131_197723_clip_path);height:100%;width:100%'></div>
    </foreignObject>
    <path
      data-figma-bg-blur-radius='10'
      d='M129.365 122.393C113.302 142.303 84.1263 145.424 64.1985 129.347C44.2707 113.269 41.1527 84.0932 57.2163 64.1828C73.2799 44.2725 102.455 41.151 122.383 57.2288C142.311 73.3065 145.429 102.482 129.365 122.393Z'
      stroke='url(#paint1_radial_18131_197723)'
      stroke-width='40'
    />
    <foreignObject x='29.7378' y='29.3608' width='127.443' height='127.436'>
      <div className='backdrop-filter:blur(5px);height:100%;width:100%'></div>
    </foreignObject>
    <path
      data-figma-bg-blur-radius='10'
      d='M123.599 117.395C110.178 134.031 85.8018 136.638 69.1529 123.206C52.5039 109.773 49.8983 85.3973 63.3196 68.762C76.741 52.1266 101.117 49.5192 117.766 62.9516C134.415 76.3839 137.02 100.76 123.599 117.395Z'
      stroke='url(#paint2_radial_18131_197723)'
      stroke-opacity='0.49'
      stroke-width='30'
    />
    <path
      d='M123.019 116.927C109.854 133.246 85.9456 135.8 69.6192 122.628C53.2927 109.456 50.7342 85.5482 63.9 69.2295C77.0659 52.9108 100.974 50.3564 117.3 63.5286C133.627 76.7008 136.185 100.608 123.019 116.927Z'
      stroke='url(#paint3_radial_18131_197723)'
      stroke-width='10'
    />
    <ellipse
      cx='155.917'
      cy='72.2455'
      rx='3.18529'
      ry='3.18433'
      transform='rotate(38.8965 155.917 72.2455)'
      fill='#8DE0D5'
    />
    <defs>
      <clipPath id='bgblur_0_18131_197723_clip_path'>
        <path
          transform='translate(-16.9448 -16.9463)'
          d='M129.365 122.393C113.302 142.303 84.1263 145.424 64.1985 129.347C44.2707 113.269 41.1527 84.0932 57.2163 64.1828C73.2799 44.2725 102.455 41.151 122.383 57.2288C142.311 73.3065 145.429 102.482 129.365 122.393Z'
        />
      </clipPath>
      <linearGradient
        id='paint0_linear_18131_197723'
        x1='126.727'
        y1='162.126'
        x2='109.091'
        y2='144.484'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#007583' />
        <stop offset='0.750282' stop-color='#9FCDD7' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_18131_197723'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(90.0162 94.3745) rotate(127.686) scale(88.3235 88.3501)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint2_radial_18131_197723'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(90.8078 93.9586) rotate(127.686) scale(71.517 71.5386)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint3_radial_18131_197723'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(91.3385 93.7822) rotate(127.686) scale(57.2136 57.2308)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
    </defs>
  </svg>
)

export const Background02Mobile = () => (
  <svg
    width='147'
    height='146'
    viewBox='0 0 147 146'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <ellipse
      cx='136.169'
      cy='107.383'
      rx='9.70626'
      ry='9.70333'
      fill='url(#paint0_linear_18131_197463)'
    />
    <foreignObject x='-9.39453' y='-10' width='166.023' height='165.979'>
      <div className='backdrop-filter:blur(5px);clip-path:url(#bgblur_0_18131_197463_clip_path);height:100%;width:100%'></div>
    </foreignObject>
    <g data-figma-bg-blur-radius='10'>
      <mask id='path-2-inside-1_18131_197463' fill='white'>
        <ellipse cx='73.6174' cy='72.9899' rx='73.0119' ry='72.9899' />
      </mask>
      <path
        d='M66.6293 72.9899C66.6293 69.0955 69.7807 65.9797 73.6174 65.9797V225.98C158.101 225.98 226.629 157.507 226.629 72.9899H66.6293ZM73.6174 65.9797C77.454 65.9797 80.6055 69.0955 80.6055 72.9899H-79.3945C-79.3945 157.507 -10.866 225.98 73.6174 225.98V65.9797ZM80.6055 72.9899C80.6055 76.8842 77.454 80 73.6174 80V-80C-10.866 -80 -79.3945 -11.5269 -79.3945 72.9899H80.6055ZM73.6174 80C69.7807 80 66.6293 76.8842 66.6293 72.9899H226.629C226.629 -11.5269 158.101 -80 73.6174 -80V80Z'
        fill='url(#paint1_radial_18131_197463)'
        mask='url(#path-2-inside-1_18131_197463)'
      />
    </g>
    <ellipse
      cx='24.4126'
      cy='54.1492'
      rx='13.6157'
      ry='13.6116'
      fill='#405985'
    />
    <foreignObject x='4.49805' y='3.59326' width='138.238' height='138.202'>
      <div className='backdrop-filter:blur(5px);clip-path:url(#bgblur_1_18131_197463_clip_path);height:100%;width:100%'></div>
    </foreignObject>
    <g data-figma-bg-blur-radius='10'>
      <mask id='path-5-inside-2_18131_197463' fill='white'>
        <ellipse cx='73.617' cy='72.6944' rx='59.119' ry='59.1011' />
      </mask>
      <path
        d='M72.736 72.6944C72.736 72.7099 72.7354 72.6626 72.7537 72.5733C72.7712 72.4874 72.7986 72.4 72.8324 72.3201C72.8968 72.1679 72.9635 72.0893 73.0004 72.0523C73.0374 72.0154 73.1141 71.9506 73.2616 71.8882C73.3393 71.8554 73.4239 71.829 73.5065 71.8121C73.5926 71.7945 73.6362 71.7955 73.617 71.7955V191.795C139.388 191.795 192.736 138.489 192.736 72.6944H72.736ZM73.617 71.7955C73.5978 71.7955 73.6414 71.7945 73.7275 71.8121C73.8101 71.829 73.8948 71.8554 73.9724 71.8882C74.12 71.9506 74.1967 72.0154 74.2336 72.0523C74.2705 72.0893 74.3372 72.1679 74.4016 72.3201C74.4354 72.4 74.4628 72.4874 74.4803 72.5733C74.4986 72.6626 74.498 72.7099 74.498 72.6944H-45.502C-45.502 138.489 7.84651 191.795 73.617 191.795V71.7955ZM74.498 72.6944C74.498 72.6789 74.4986 72.7261 74.4803 72.8154C74.4628 72.9013 74.4354 72.9888 74.4016 73.0687C74.3372 73.2209 74.2705 73.2995 74.2336 73.3364C74.1967 73.3733 74.12 73.4381 73.9724 73.5005C73.8948 73.5333 73.8101 73.5597 73.7275 73.5766C73.6414 73.5942 73.5978 73.5933 73.617 73.5933V-46.4067C7.84651 -46.4067 -45.502 6.89956 -45.502 72.6944H74.498ZM73.617 73.5933C73.6362 73.5933 73.5926 73.5942 73.5065 73.5766C73.4239 73.5597 73.3393 73.5333 73.2616 73.5005C73.1141 73.4381 73.0374 73.3733 73.0004 73.3364C72.9635 73.2995 72.8968 73.2209 72.8324 73.0687C72.7986 72.9888 72.7712 72.9013 72.7537 72.8154C72.7354 72.7261 72.736 72.6789 72.736 72.6944H192.736C192.736 6.89956 139.388 -46.4067 73.617 -46.4067V73.5933Z'
        fill='url(#paint2_radial_18131_197463)'
        fill-opacity='0.49'
        mask='url(#path-5-inside-2_18131_197463)'
      />
    </g>
    <mask id='path-7-inside-3_18131_197463' fill='white'>
      <ellipse cx='73.6174' cy='72.694' rx='47.2952' ry='47.2809' />
    </mask>
    <path
      d='M40.9126 72.694C40.9126 54.6009 55.5778 39.9748 73.6174 39.9748V199.975C143.898 199.975 200.913 143.012 200.913 72.694H40.9126ZM73.6174 39.9748C91.657 39.9748 106.322 54.6009 106.322 72.694H-53.6777C-53.6777 143.012 3.33702 199.975 73.6174 199.975V39.9748ZM106.322 72.694C106.322 90.787 91.657 105.413 73.6174 105.413V-54.5869C3.33702 -54.5869 -53.6777 2.3759 -53.6777 72.694H106.322ZM73.6174 105.413C55.5778 105.413 40.9126 90.787 40.9126 72.694H200.913C200.913 2.3759 143.898 -54.5869 73.6174 -54.5869V105.413Z'
      fill='url(#paint3_radial_18131_197463)'
      mask='url(#path-7-inside-3_18131_197463)'
    />
    <ellipse
      cx='112.712'
      cy='11.6973'
      rx='3.50504'
      ry='3.50398'
      fill='#4DB8BA'
    />
    <defs>
      <clipPath id='bgblur_0_18131_197463_clip_path'>
        <ellipse
          transform='translate(9.39453 10)'
          cx='73.6174'
          cy='72.9899'
          rx='73.0119'
          ry='72.9899'
        />
      </clipPath>
      <clipPath id='bgblur_1_18131_197463_clip_path'>
        <ellipse
          transform='translate(-4.49805 -3.59326)'
          cx='73.617'
          cy='72.6944'
          rx='59.119'
          ry='59.1011'
        />
      </clipPath>
      <linearGradient
        id='paint0_linear_18131_197463'
        x1='145.875'
        y1='117.086'
        x2='126.469'
        y2='97.6738'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#42A7C3' />
        <stop offset='0.750282' stop-color='#8ADBF0' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_18131_197463'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(71.5639 76.1832) rotate(88.7893) scale(97.1894 97.2188)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint2_radial_18131_197463'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(71.9543 75.28) rotate(88.7893) scale(78.6959 78.7197)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint3_radial_18131_197463'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(72.2872 74.7625) rotate(88.7893) scale(62.9567 62.9757)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
    </defs>
  </svg>
)

export const Background03Mobile = () => (
  <svg
    width='147'
    height='146'
    viewBox='0 0 147 146'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <ellipse
      cx='114.64'
      cy='65.175'
      rx='9.70626'
      ry='9.70333'
      fill='url(#paint0_linear_18131_197712)'
    />
    <foreignObject x='-9.41895' y='-10' width='166.023' height='165.979'>
      <div className='backdrop-filter:blur(5px);clip-path:url(#bgblur_0_18131_197712_clip_path);height:100%;width:100%'></div>
    </foreignObject>
    <g data-figma-bg-blur-radius='10'>
      <mask id='path-2-inside-1_18131_197712' fill='white'>
        <ellipse cx='73.593' cy='72.9899' rx='73.0119' ry='72.9899' />
      </mask>
      <path
        d='M66.6049 72.9899C66.6049 69.0955 69.7563 65.9797 73.593 65.9797V225.98C158.076 225.98 226.605 157.507 226.605 72.9899H66.6049ZM73.593 65.9797C77.4296 65.9797 80.5811 69.0955 80.5811 72.9899H-79.4189C-79.4189 157.507 -10.8904 225.98 73.593 225.98V65.9797ZM80.5811 72.9899C80.5811 76.8842 77.4296 80 73.593 80V-80C-10.8904 -80 -79.4189 -11.5269 -79.4189 72.9899H80.5811ZM73.593 80C69.7563 80 66.6049 76.8842 66.6049 72.9899H226.605C226.605 -11.5269 158.076 -80 73.593 -80V80Z'
        fill='url(#paint1_radial_18131_197712)'
        mask='url(#path-2-inside-1_18131_197712)'
      />
    </g>
    <ellipse
      cx='58.1343'
      cy='18.5545'
      rx='13.6157'
      ry='13.6116'
      fill='#5858DF'
    />
    <foreignObject x='4.47363' y='3.59326' width='138.238' height='138.202'>
      <div className='backdrop-filter:blur(5px);clip-path:url(#bgblur_1_18131_197712_clip_path);height:100%;width:100%'></div>
    </foreignObject>
    <g data-figma-bg-blur-radius='10'>
      <mask id='path-5-inside-2_18131_197712' fill='white'>
        <ellipse cx='73.5926' cy='72.6944' rx='59.119' ry='59.1011' />
      </mask>
      <path
        d='M72.7115 72.6944C72.7115 72.7099 72.711 72.6626 72.7293 72.5733C72.7468 72.4874 72.7741 72.4 72.808 72.3201C72.8723 72.1679 72.9391 72.0893 72.976 72.0523C73.0129 72.0154 73.0896 71.9506 73.2372 71.8882C73.3148 71.8554 73.3995 71.829 73.4821 71.8121C73.5682 71.7945 73.6118 71.7955 73.5926 71.7955V191.795C139.363 191.795 192.712 138.489 192.712 72.6944H72.7115ZM73.5926 71.7955C73.5734 71.7955 73.617 71.7945 73.7031 71.8121C73.7857 71.829 73.8703 71.8554 73.948 71.8882C74.0955 71.9506 74.1722 72.0154 74.2092 72.0523C74.2461 72.0893 74.3128 72.1679 74.3772 72.3201C74.411 72.4 74.4384 72.4874 74.4559 72.5733C74.4742 72.6626 74.4736 72.7099 74.4736 72.6944H-45.5264C-45.5264 138.489 7.82209 191.795 73.5926 191.795V71.7955ZM74.4736 72.6944C74.4736 72.6789 74.4742 72.7261 74.4559 72.8154C74.4384 72.9013 74.411 72.9888 74.3772 73.0687C74.3128 73.2209 74.2461 73.2995 74.2092 73.3364C74.1722 73.3733 74.0955 73.4381 73.948 73.5005C73.8703 73.5333 73.7857 73.5597 73.7031 73.5766C73.617 73.5942 73.5734 73.5933 73.5926 73.5933V-46.4067C7.82209 -46.4067 -45.5264 6.89956 -45.5264 72.6944H74.4736ZM73.5926 73.5933C73.6118 73.5933 73.5682 73.5942 73.4821 73.5766C73.3995 73.5597 73.3148 73.5333 73.2372 73.5005C73.0896 73.4381 73.0129 73.3733 72.976 73.3364C72.9391 73.2995 72.8723 73.2209 72.808 73.0687C72.7741 72.9888 72.7468 72.9013 72.7293 72.8154C72.711 72.7261 72.7115 72.6789 72.7115 72.6944H192.712C192.712 6.89956 139.363 -46.4067 73.5926 -46.4067V73.5933Z'
        fill='url(#paint2_radial_18131_197712)'
        fill-opacity='0.49'
        mask='url(#path-5-inside-2_18131_197712)'
      />
    </g>
    <mask id='path-7-inside-3_18131_197712' fill='white'>
      <ellipse cx='73.593' cy='72.694' rx='47.2952' ry='47.2809' />
    </mask>
    <path
      d='M40.8882 72.694C40.8882 54.6009 55.5534 39.9748 73.593 39.9748V199.975C143.873 199.975 200.888 143.012 200.888 72.694H40.8882ZM73.593 39.9748C91.6326 39.9748 106.298 54.6009 106.298 72.694H-53.7021C-53.7021 143.012 3.31261 199.975 73.593 199.975V39.9748ZM106.298 72.694C106.298 90.787 91.6326 105.413 73.593 105.413V-54.5869C3.31261 -54.5869 -53.7021 2.3759 -53.7021 72.694H106.298ZM73.593 105.413C55.5534 105.413 40.8882 90.787 40.8882 72.694H200.888C200.888 2.3759 143.873 -54.5869 73.593 -54.5869V105.413Z'
      fill='url(#paint3_radial_18131_197712)'
      mask='url(#path-7-inside-3_18131_197712)'
    />
    <ellipse
      cx='138.371'
      cy='40.8511'
      rx='3.50504'
      ry='3.50398'
      fill='#4DB8BA'
    />
    <defs>
      <clipPath id='bgblur_0_18131_197712_clip_path'>
        <ellipse
          transform='translate(9.41895 10)'
          cx='73.593'
          cy='72.9899'
          rx='73.0119'
          ry='72.9899'
        />
      </clipPath>
      <clipPath id='bgblur_1_18131_197712_clip_path'>
        <ellipse
          transform='translate(-4.47363 -3.59326)'
          cx='73.5926'
          cy='72.6944'
          rx='59.119'
          ry='59.1011'
        />
      </clipPath>
      <linearGradient
        id='paint0_linear_18131_197712'
        x1='124.346'
        y1='74.8783'
        x2='104.939'
        y2='55.4658'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#42A7C3' />
        <stop offset='0.750282' stop-color='#8ADBF0' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_18131_197712'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(71.5395 76.1832) rotate(88.7893) scale(97.1894 97.2188)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint2_radial_18131_197712'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(71.9299 75.28) rotate(88.7893) scale(78.6959 78.7197)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
      <radialGradient
        id='paint3_radial_18131_197712'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(72.2628 74.7625) rotate(88.7893) scale(62.9567 62.9757)'
      >
        <stop offset='0.654764' stop-color='#E2F6FC' stop-opacity='0.36' />
        <stop offset='1' stop-color='#48B7D6' stop-opacity='0.84' />
      </radialGradient>
    </defs>
  </svg>
)
